import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  qalBoxgetShorts,
} from '../../services/mp-cf-api-service';

const getQalboxShort = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setOperationData ] = useState(null);
  const {
    searchConfig,
    onOperationComplete,
  } = updateData || {};

  const getQalboxShortItems = async () => {
    try {
      console.log(`QalBox getting short Media...`);
      setResponseData({
        isLoading: true,
        isError: false,
      });

      const shortMediaItemsApiResp = await qalBoxgetShorts(searchConfig);

      const responseData = shortMediaItemsApiResp;

      let errorMsg = null;
      let isError = false;

      if(responseData) {
        console.log('QalBox getting short Media items add/update Success!!');
      } else {
        console.log('QalBox getting short Media items add/update Failed!!');
        errorMsg = `Failed to getshort Media items.`;
        isError = true;
      }

      setResponseData({
        isLoading: false,
        isError,
        errorMsg,
        data: responseData,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData,
        });
      }
    } catch (err) {
      console.log('Something went wrong while getting short Media items. ', err);
      const errorMsg = `Error occurred while getting short Media items.`;
      setResponseData({
        isLoading: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      getQalboxShortItems();
    }
  }, [ updateData ]);

  return [
    responseData,
    setOperationData,
  ];
};

export default getQalboxShort;
